import React, { createContext, useContext, useMemo } from 'react';
import { useSellerId } from '../../hooks/useSellerId';
import { type BIEvents, createEvents } from './events';
import { useProfessionBIExtensionData } from './utils/useProfessionBIExtensionData';

const BIContext = createContext<BIEvents | null>(null);

interface BIProviderProps {
    readonly children: React.ReactNode;
}

export const BIProvider = ({ children }: BIProviderProps) => {
    const sellerId = useSellerId();
    const professionExtension = useProfessionBIExtensionData();

    const events = useMemo<BIEvents>(
        () => createEvents({ sellerId, professionExtension }),
        [sellerId, professionExtension]
    );

    return <BIContext.Provider value={events}>{children}</BIContext.Provider>;
};

export const useBI = (): BIEvents => {
    const bi = useContext(BIContext);
    if (!bi) {
        throw new TypeError('"useBI" must be used inside "BIProvider" root component');
    }
    return bi;
};
